/*
 * Created on 10.11.2016
 *
 * Copyright(c) 1995 - 2016 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { Component, Input } from '@angular/core';

/**
 * Diese Komponente stellt die Anzeige des Schritts 1 - x in einem Formular zur Verfügung.
 *
 * @author Valentin Kennke (vake@mms-dresden.de)(valentin.kennke@t-systems.com)
 * @author Thomas Hamm (thm@mms-dresden.de)
 */
@Component({
    selector: 'common-form-progress-step',
    templateUrl: 'progress-step.component.html'
})
export class ProgressStepComponent {
    @Input() step: number;
    @Input() maxSteps: number;
    @Input() stepNames: string[] = ['Schritt', 'Schritt', 'Schritt'];

    public progressStep(stepNumber: number) {
        return this.stepNames[stepNumber];
    }

}
